import React from "react"

import { connect } from "scrivito"
import { ProductImage } from "scrivito/Objs/Product/Components/ProductImage"
import { ProductObj } from "scrivito/Objs/Product/ProductObjClass"
import { MediaOption } from "shared/ui/media-option/MediaOption"
import { TextHighlighter } from "shared/ui/text-highlighter/TextHighlighter"

import { ProductOption } from "../../../../types/GlobalSearch"
import { GlobalSearchListItem } from "./GlobalSearchListItem"

interface ProductGlobalSearchListItemProps {
  option: ProductOption
  index: number
  isTabActive: boolean
}

const ProductGlobalSearchListItemContent = connect(
  ({ option }: Pick<ProductGlobalSearchListItemProps, "option">) => {
    const { obj, variantKey, articleNumber } = option.data
    const kind =
      obj.objClass() === "ProductBaseVariant"
        ? (obj.parent()?.get("kind") as string) ?? null
        : ((obj as ProductObj).get("kind") as string) ?? null
    const descriptionShort = obj.get("descriptionShort")

    return (
      <MediaOption.Root variant="product">
        <MediaOption.Media aria-hidden>
          <ProductImage obj={obj} />
        </MediaOption.Media>
        <MediaOption.Label>
          <TextHighlighter
            text={option.label}
            searchTerm={option.data.matchInfo.title?.searchTerm}
            ranges={option.data.matchInfo.title?.ranges}
          />
        </MediaOption.Label>

        <MediaOption.Subtext>
          {descriptionShort || kind ? (
            <span className="global-search__item-subtext-part">
              {descriptionShort || kind}
            </span>
          ) : null}
          {articleNumber ? (
            <span className="global-search__item-subtext-part">
              <TextHighlighter
                text={articleNumber}
                searchTerm={option.data.matchInfo.articleNumber?.searchTerm}
                ranges={option.data.matchInfo.articleNumber?.ranges}
              />
            </span>
          ) : null}
          {variantKey ? (
            <span className="global-search__item-subtext-part">
              <TextHighlighter
                text={variantKey}
                searchTerm={option.data.matchInfo.variantKey?.searchTerm}
                ranges={option.data.matchInfo.variantKey?.ranges}
              />
            </span>
          ) : null}
        </MediaOption.Subtext>
      </MediaOption.Root>
    )
  }
)

export const ProductGlobalSearchListItem = React.memo(
  ({ option, index, isTabActive }: ProductGlobalSearchListItemProps) => {
    return (
      <GlobalSearchListItem
        className="global-search__list-item--product"
        index={index}
        option={option}
        isTabActive={isTabActive}
      >
        <ProductGlobalSearchListItemContent option={option} />
      </GlobalSearchListItem>
    )
  }
)
